/*
  Add here your own custom javascript codes
*/

const homeEssentialsProductActions = {
	favorite: {
		key: "homeEssentialsFavorites",
		activeLabel: "Remove from favorites",
		inactiveLabel: "Add to favorites",
	},
	compare: {
		key: "homeEssentialsCompare",
		activeLabel: "Remove from comparison",
		inactiveLabel: "Add to comparison",
	},
};

const getStoredProducts = (key) => {
	try {
		return JSON.parse(localStorage.getItem(key)) || [];
	} catch (error) {
		return [];
	}
};

const setStoredProducts = (key, products) => {
	localStorage.setItem(key, JSON.stringify(products));
};

const isSafeStorePath = (url) => typeof url === "string" && url.startsWith("/");

const createProductImage = (product, size = "default") => {
	if (!product.image) return null;

	const image = document.createElement("img");
	image.src = product.image;
	image.alt = product.title || "Saved product";
	image.loading = "lazy";

	if (size === "compare") {
		image.width = 120;
		image.height = 120;
	}

	return image;
};

const updateProductActionButtons = () => {
	document.querySelectorAll("[data-product-action]").forEach((button) => {
		const action = homeEssentialsProductActions[button.dataset.productAction];

		if (!action) return;

		const products = getStoredProducts(action.key);
		const isActive = products.some(
			(product) => product.id === button.dataset.productId,
		);
		const label = isActive ? action.activeLabel : action.inactiveLabel;

		button.classList.toggle("active", isActive);
		button.setAttribute("aria-pressed", String(isActive));
		button.setAttribute(
			"aria-label",
			`${label} ${button.dataset.productTitle}`,
		);
	});

	updateSavedProductCounts();
};

const updateSavedProductCounts = () => {
	Object.entries(homeEssentialsProductActions).forEach(([type, action]) => {
		const count = getStoredProducts(action.key).length;

		document
			.querySelectorAll(`[data-saved-count="${type}"]`)
			.forEach((badge) => {
				badge.textContent = String(count);
				badge.toggleAttribute("hidden", count === 0);
			});
	});
};

const showSavedProductNotice = (type, product) => {
	const label = type === "compare" ? "comparison" : "favorites";
	const url = type === "compare" ? "/pages/compare" : "/pages/wishlist";
	const existingNotice = document.querySelector("[data-saved-product-notice]");

	existingNotice?.remove();

	const notice = document.createElement("aside");
	notice.className = "saved-product-notice";
	notice.setAttribute("data-saved-product-notice", "");
	notice.setAttribute("role", "status");
	notice.setAttribute("aria-live", "polite");

	const image = createProductImage(product);
	const copy = document.createElement("div");
	const title = document.createElement("strong");
	const subtitle = document.createElement("span");
	const link = document.createElement("a");

	title.textContent = `Added to ${label}`;
	subtitle.textContent = product.title || "Saved product";
	link.href = url;
	link.textContent = "View";

	if (image) notice.append(image);
	copy.append(title, subtitle);
	notice.append(copy, link);
	document.body.append(notice);

	window.setTimeout(() => {
		notice.classList.add("is-hiding");
		window.setTimeout(() => notice.remove(), 220);
	}, 3200);
};

const addCompareHeaderCell = (row, product) => {
	const cell = document.createElement("th");
	const image = createProductImage(product, "compare");
	const title = document.createElement("span");

	cell.scope = "col";
	title.textContent = product.title || "Saved product";

	if (image) cell.append(image);
	cell.append(title);
	row.append(cell);
};

const addCompareValueRow = (body, label, products, getValue) => {
	const row = document.createElement("tr");
	const heading = document.createElement("th");

	heading.scope = "row";
	heading.textContent = label;
	row.append(heading);

	products.forEach((product) => {
		const cell = document.createElement("td");
		cell.textContent = getValue(product) || "Not listed";
		row.append(cell);
	});

	body.append(row);
};

const renderCompareTable = (page, products) => {
	if (products.length < 2) return;

	const wrap = document.createElement("section");
	const scroll = document.createElement("div");
	const table = document.createElement("table");
	const caption = document.createElement("caption");
	const head = document.createElement("thead");
	const headRow = document.createElement("tr");
	const detailHeader = document.createElement("th");
	const body = document.createElement("tbody");

	wrap.className = "compare-table-wrap";
	wrap.setAttribute("aria-label", "Product comparison table");
	scroll.className = "compare-table-scroll";
	table.className = "compare-table";
	caption.textContent = "Compare selected products";
	detailHeader.scope = "col";
	detailHeader.textContent = "Details";

	headRow.append(detailHeader);
	products.forEach((product) => addCompareHeaderCell(headRow, product));
	head.append(headRow);

	addCompareValueRow(body, "Price", products, (product) => product.price);
	addCompareValueRow(
		body,
		"Availability",
		products,
		(product) => product.available,
	);
	addCompareValueRow(body, "Brand", products, (product) => product.vendor);
	addCompareValueRow(body, "Category", products, (product) => product.type);

	const actionRow = document.createElement("tr");
	const actionHeader = document.createElement("th");
	actionHeader.scope = "row";
	actionHeader.textContent = "Action";
	actionRow.append(actionHeader);

	products.forEach((product) => {
		const cell = document.createElement("td");
		const link = document.createElement("a");

		link.href = isSafeStorePath(product.url) ? product.url : "#";
		link.className = "btn btn-outline-primary";
		link.textContent = "View product";
		cell.append(link);
		actionRow.append(cell);
	});

	body.append(actionRow);
	table.append(caption, head, body);
	scroll.append(table);
	wrap.append(scroll);
	page.append(wrap);
};

const updateCompareEmptyState = (empty, products) => {
	if (!empty) return;

	const message = empty.querySelector("p");

	if (!message) return;

	// ELI5: Comparing needs two things. With only one product, there is nothing to compare it against.
	message.textContent =
		products.length === 0
			? "Add at least 2 products before the comparison table works."
			: "Add 1 more product to unlock the comparison table.";
};

const renderSavedProductCard = (page, product) => {
	const safeUrl = isSafeStorePath(product.url) ? product.url : "#";
	const card = document.createElement("article");
	const link = document.createElement("a");
	const title = document.createElement("span");
	const remove = document.createElement("button");
	const image = createProductImage(product);

	card.className = "saved-product-card";
	link.href = safeUrl;
	title.textContent = product.title || "Saved product";
	remove.type = "button";
	remove.dataset.removeSavedProduct = product.id || "";
	remove.textContent = "Remove";

	if (image) link.append(image);
	link.append(title);

	if (product.price) {
		const price = document.createElement("small");
		price.textContent = product.price;
		link.append(price);
	}

	card.append(link, remove);
	page.append(card);
};

const renderSavedProductsPage = () => {
	const page = document.querySelector("[data-saved-products-page]");

	if (!page) return;

	const type = page.dataset.savedProductsType;
	const action = homeEssentialsProductActions[type];
	const empty = page.querySelector("[data-saved-products-empty]");
	const summary = document.querySelector("[data-saved-products-page-summary]");

	if (!action) return;

	const products = getStoredProducts(action.key);
	const isComparePage = type === "compare";
	const hasEnoughCompareProducts = !isComparePage || products.length >= 2;

	page
		.querySelectorAll(".saved-product-card, .compare-table-wrap")
		.forEach((element) => element.remove());
	empty?.toggleAttribute(
		"hidden",
		hasEnoughCompareProducts ? products.length > 0 : false,
	);

	if (isComparePage && products.length < 2) {
		updateCompareEmptyState(empty, products);
	}

	if (summary) {
		if (isComparePage && products.length < 2) {
			summary.textContent =
				products.length === 1
					? "1 product added. Add 1 more to compare."
					: "Add 2 products to start comparing.";
		} else {
			summary.textContent =
				products.length === 1
					? "1 product saved."
					: `${products.length} products saved.`;
		}
	}

	// ELI5: The comparison table appears only after two products are saved, because one product alone cannot be compared.
	if (isComparePage) {
		renderCompareTable(page, products);
	}

	products.forEach((product) => renderSavedProductCard(page, product));
};

document.addEventListener("click", (event) => {
	const button = event.target.closest("[data-product-action]");

	if (!button) return;

	event.preventDefault();

	const action = homeEssentialsProductActions[button.dataset.productAction];

	if (!action) return;

	const product = {
		id: button.dataset.productId,
		handle: button.dataset.productHandle,
		title: button.dataset.productTitle,
		url: button.dataset.productUrl,
		image: button.dataset.productImage,
		price: button.dataset.productPrice,
		vendor: button.dataset.productVendor,
		type: button.dataset.productType,
		available: button.dataset.productAvailable,
	};

	const products = getStoredProducts(action.key);
	const exists = products.some(
		(storedProduct) => storedProduct.id === product.id,
	);
	const nextProducts = exists
		? products.filter((storedProduct) => storedProduct.id !== product.id)
		: [...products, product];

	setStoredProducts(action.key, nextProducts);
	updateProductActionButtons();
	renderSavedProductsPage();

	if (!exists) {
		showSavedProductNotice(button.dataset.productAction, product);
	}
});

document.addEventListener("click", async (event) => {
	const button = event.target.closest("[data-product-purchase]");

	if (!button || button.disabled) return;

	event.preventDefault();

	const variantId = button.dataset.variantId;

	if (!variantId) return;

	if (button.dataset.productPurchase === "buy") {
		window.location.href = `/cart/${variantId}:1`;
		return;
	}

	const previousLabel = button.textContent;
	const formData = new FormData();
	formData.append("id", variantId);
	formData.append("quantity", "1");

	button.disabled = true;
	button.textContent = "Adding";

	try {
		const cart = document.querySelector("cart-container");

		if (cart?.add) {
			await cart.add(formData);
		} else {
			await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
				method: "POST",
				body: formData,
			});
		}

		button.textContent = "Added";
		setTimeout(() => {
			button.textContent = previousLabel;
			button.disabled = false;
		}, 1200);
	} catch (error) {
		button.textContent = "Try again";
		setTimeout(() => {
			button.textContent = previousLabel;
			button.disabled = false;
		}, 1600);
	}
});

document.addEventListener("click", (event) => {
	const removeButton = event.target.closest("[data-remove-saved-product]");

	if (!removeButton) return;

	const page = removeButton.closest("[data-saved-products-page]");
	const action = homeEssentialsProductActions[page?.dataset.savedProductsType];

	if (!action) return;

	const products = getStoredProducts(action.key).filter(
		(product) => product.id !== removeButton.dataset.removeSavedProduct,
	);

	setStoredProducts(action.key, products);
	updateProductActionButtons();
	renderSavedProductsPage();
});

document.addEventListener("click", (event) => {
	const button = event.target.closest("[data-back-to-top]");

	if (!button) return;

	window.scrollTo({ top: 0, behavior: "smooth" });
});

document.addEventListener("DOMContentLoaded", () => {
	updateProductActionButtons();
	renderSavedProductsPage();
});
window.addEventListener("kt.collection.loaded", () => {
	updateProductActionButtons();
	renderSavedProductsPage();
});

const initAboutFoundationTabs = () => {
	document.querySelectorAll("[data-foundation-tabs]").forEach((root) => {
		if (root.dataset.foundationTabsReady === "true") return;

		const image = root.querySelector("[data-foundation-image]");
		const tabs = root.querySelectorAll("[data-foundation-tab]");

		if (!image || !tabs.length) return;

		root.dataset.foundationTabsReady = "true";
		tabs.forEach((tab) => {
			tab.addEventListener("click", () => {
				tabs.forEach((item) => {
					const active = item === tab;
					item.classList.toggle("is-active", active);
					item.setAttribute("aria-selected", String(active));
				});

				image.classList.add("is-switching");
				window.setTimeout(() => {
					image.src = tab.dataset.foundationImage;
					image.alt = tab.dataset.foundationAlt || "Selected Home Essentials product";
					image.classList.remove("is-switching");
				}, 140);
			});
		});
	});
};

initAboutFoundationTabs();
document.addEventListener("DOMContentLoaded", initAboutFoundationTabs);
document.addEventListener("shopify:section:load", initAboutFoundationTabs);
